export default __webpack_public_path__ + "static/media/onep-logo.a90f03d7.png";